//NEW: UI_REVAMP
import { Flex, Text, VStack } from '@chakra-ui/react';
import { currencyFormat } from '../../utils/numberFormat';
import { ConvertedTime } from '../../utils/Time';
import BetListAccordion from '../betting/BetListAccordion';

const BetResultSection = ({
	title,
	totalAmount,
	gradientTextColor,
	bets,
	drawTime,
	columns,
	textColor,
	isImage = false,
}) => {
	if (bets.length === 0 && (totalAmount === 0 || totalAmount === undefined)) return null;

	const categories = bets.reduce((acc, b) => {
		const betType = b.ramble ? 'Ramble' : 'Straight';
		if (!acc.find((c) => c.gameType === b.gameType && c.betType === betType)) {
			acc.push({ gameType: b.gameType, betType: betType });
		}
		return acc;
	}, []);

	return (
		<VStack align='stretch' spacing={2}>
			<Flex justifyContent='space-between' alignItems='center'>
				<Text
					bgGradient={gradientTextColor}
					bgClip='text'
					sx={{
						WebkitBackgroundClip: 'text',
						WebkitTextFillColor: 'transparent',
					}}
					fontWeight={600}
					fontSize='16px'
					color={textColor}
				>
					{title} Bet List
				</Text>

				<Text
					bgGradient={gradientTextColor}
					bgClip='text'
					sx={{
						WebkitBackgroundClip: 'text',
						WebkitTextFillColor: 'transparent',
					}}
					fontSize='22px'
					fontWeight={700}
					color={textColor}
				>
					PHP {currencyFormat(totalAmount || 0)}
				</Text>
			</Flex>

			{categories.map((cat) => {
				const { gameType, betType } = cat;
				const catBets = bets.filter(
					(b) => b.gameType === gameType && (b.ramble ? 'Ramble' : 'Straight') === betType,
				);

				const transformedData = catBets.map((item) => ({
					id: `res-${Math.random()}`,
					digit: item.number.map((n) => n.digit).join(item.gameType === 'EZ2' ? ' ' : ''),
					timeName: ConvertedTime({ time: drawTime, format: 'h:mm A' }),
					betPrice: item.betPrice,
					gameType: item.gameType,
					betType: item.ramble ? 'Ramble' : 'Straight',
					winRate: item.winRate,
					isLuckyPick: item.lp,
				}));

				return (
					<BetListAccordion
						key={`${title}-${gameType}-${betType}`}
						columns={columns}
						gameType={gameType}
						betType={betType}
						data={transformedData}
						isResult={true}
						isImage={isImage}
					/>
				);
			})}
		</VStack>
	);
};

const BetResultList = ({ results, isImage = false, ...props }) => {
	const columns = [
		{ key: 'digit', label: 'Numbers', align: 'flex-start' },
		{ key: 'betPrice', label: 'Bet Price (PHP)', align: 'flex-end' },
		{ key: 'odds', label: 'Odds', align: 'flex-end' },
	];

	if (!results || !results.betting) return null;

	const successBets = results.betting.filter((b) => !b.isFail);
	const failBets = results.betting.filter((b) => b.isFail);

	return (
		<VStack spacing={4} align='stretch' {...props}>
			<BetResultSection
				title='Successful'
				totalAmount={results.totalSuccessPrice}
				gradientTextColor={isImage ? null : 'linear-gradient(180deg, #01A13D 0%, #09632B 100%)'}
				bets={successBets}
				drawTime={results.drawTime}
				columns={columns}
				isImage={isImage}
				textColor={isImage ? 'green' : null}
			/>
			<BetResultSection
				title='Failed'
				totalAmount={results.totalFailPrice}
				gradientTextColor={isImage ? null : 'linear(to-b, #D81A80, #E81B22)'}
				bets={failBets}
				drawTime={results.drawTime}
				columns={columns}
				isImage={isImage}
				textColor={isImage ? 'red' : null}
			/>
		</VStack>
	);
};

export default BetResultList;
